import { useCallback } from "react";
import { globalEvents } from "../../../common/GlobalEvents";
export var useGlobalEventTag = function (value) {
    return useCallback(function () {
        globalEvents.emit(value);
    }, [value]);
};
